import React, { useState } from "react";
import { participantsAPI } from "../../../api/apiClient";
import useApi from "../../CustomHooks/useApi";
import Loading from "../../../Loading";
import "../../../css/View/ParticipantCorrections.css";
import { useTripContext } from "../TripContext";

const ParticipantCorrections = ({ participantGuid, corrections, canBeEdited }) => {
  const [showAddPopup, setShowAddPopup] = useState(false);
  const [showDeletePopup, setShowDeletePopup] = useState(false);
  const [newCorrection, setNewCorrection] = useState({ amount: "", note: "" });
  const [selectedToDelete, setSelectedToDelete] = useState([]);
  const { updateRegistrationInContext } = useTripContext();
  const {
    callApi: addCorrections,
    isLoading: isAdding
  } = useApi();

  const {
    callApi: deleteCorrections,
    isLoading: isDeleting
  } = useApi();

  const handleAdd = async () => {
    const parsedAmount = parseFloat(newCorrection.amount);

    if (isNaN(parsedAmount) || newCorrection.note.trim() === "") {
      alert("Dodawana korekta musi posiadać poprawną kwotę i opis");
      return;
    }
    setShowAddPopup(false);
    await addCorrections(() => participantsAPI.addCorrections(participantGuid, [newCorrection]), async (response) => {
      await updateRegistrationInContext(response);
      setNewCorrection({ amount: "", note: "" });
    });
  };

  const handleDelete = async () => {
    const toDeleteGuids = selectedToDelete.map((i) => corrections[i].guid);
    setShowDeletePopup(false);
    await deleteCorrections(() => participantsAPI.deleteCorrections(participantGuid, toDeleteGuids), async (response) => {
      await updateRegistrationInContext(response);
      setSelectedToDelete([]);
    });
  };

  const toggleDeleteSelection = (index) => {
    setSelectedToDelete((prev) =>
      prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index]
    );
  };

  return (
    <div className="corrections-section">
      <div className="corrections-header">
        <strong>Korekty:</strong>
        {canBeEdited && <div className="corrections-icons">
          <i
            className={`fa-solid ${isAdding ? "fa-spinner fa-spin" : "fa-plus"} add-icon`}
            onClick={() => !isAdding && setShowAddPopup(true)}
            style={{ marginRight: "10px" }}
          ></i>
          <i
            className={`fa-solid ${isDeleting ? "fa-spinner fa-spin" : "fa-trash"} delete-icon`}
            onClick={() => !isDeleting && setShowDeletePopup(true)}
          ></i>
        </div>}
      </div>

      {(isAdding || isDeleting) ? <Loading text="Aktualizowanie korekt..."/> : corrections.map((correction, index) => (
        <div className={`correction-item ${selectedToDelete.includes(index) ? "selected-delete" : ""}`} key={index}>
          <span className="correction-desc">- {correction.note}</span>
          <span className={`correction-amount ${correction.amount < 0 ? "negative" : "positive"}`}>
            {correction.amount > 0 && "+"}
            {correction.amount.toFixed(2)} zł
          </span>
        </div>
      ))}

      {showAddPopup && (
        <div className="correction-popup-overlay">
          <div className="correction-popup">
            <h4>Dodaj korektę</h4>
            <input
              type="number"
              placeholder="Kwota"
              value={newCorrection.amount}
              onChange={(e) => setNewCorrection({ ...newCorrection, amount: e.target.value })}
            />
            <input
              type="text"
              placeholder="Opis"
              value={newCorrection.note}
              onChange={(e) => setNewCorrection({ ...newCorrection, note: e.target.value })}
            />
            <div className="popup-buttons">
            <button className="popup-btn popup-add" onClick={handleAdd}>Dodaj</button>
            <button className="popup-btn" onClick={() => {setNewCorrection({ amount: "", note: "" }); setShowAddPopup(false);}}>Anuluj</button>
            </div>
          </div>
        </div>
      )}

      {showDeletePopup && (
        <div className="correction-popup-overlay">
          <div className="correction-popup">
            <h4>Wybierz korekty do usunięcia</h4>
            {corrections.map((correction, index) => (
                    <div
                        key={index}
                        className={`delete-select-item ${selectedToDelete.includes(index) ? "selected-delete" : ""}`}
                        onClick={() => toggleDeleteSelection(index)}
                    >
                        {correction.note} ({correction.amount.toFixed(2)} zł)
                    </div>
                    ))}
            <div className="popup-buttons">
            <button className="popup-btn popup-delete" onClick={handleDelete}>Usuń wybrane</button>
            <button className="popup-btn" onClick={() => setShowDeletePopup(false)}>Anuluj</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ParticipantCorrections;
